<template>
  <div id="splash">
    <div class="splash-body">
      <h1 style="font-style: oblique; ">The Evolution of  <br/>European Motorways 1920–2020</h1>
      <div class="splash-cols">
        <h2>Motorways have dramatically reshaped <br/>landscapes around the world while changing <br/>the way we are connected. This visualisation <br/>reveals the history of their growth across <br/>Europe and its uneven nature.</h2>
        <span >
          This visualisation was produced <br/>as part of the exhibition <br/><a target="_blank" href="https://www.vam.ac.uk/cars" style="font-weight:bold;">Cars: Accelerating the Modern World</a>,&#160;<br/>23 November 2019—19 April 2020
          <br/><br/>Designed and developed by <br/><a target="_blank" href="http://studiofolder.it">Studio Folder</a> and Angelo Semeraro
          <div>
            <a target="_blank" class="data-download" href="https://github.com/StudioFolder/european-motorways/">Download the data</a>
          </div>
        </span>

      </div>

    </div>
    <div class="splash-footer">
      <a target="_blank" href="https://www.vam.ac.uk/"><img class="logo" src="@/assets/icons/logo-VAM.svg"/></a>
      <!--<div class="scroll-icon" />-->
      <social-sharing :url="baseURL+'/commissions/european-motorways-1920-2020/'"
                title="The Evolution of European Motorways 1920-2020"
                description="Motorways have dramatically reshaped landscapes around the world while changing the way we are connected. This visualisation reveals the history of their growth across Europe and its uneven nature"
                inline-template>
        <div class="fact-share">
          <network network="facebook"><img src="@/assets/icons/share-fb.svg"/></network>
          <network network="twitter"><img src="@/assets/icons/share-tw.svg"/></network>
        </div>
      </social-sharing>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'splash',
  components: {
  },
  computed:{
    baseURL: function(){
      return this.$store.state.baseURL;
    }
  },
  data() {
    return {
    }
  },
  mounted: function(){
  }
}
</script>
<style lang="scss">
#splash{
  width:100vw;
  height:100vh;
  background:transparent;
  display:flex;
  flex-direction: column;
  background:black;
  background:linear-gradient(black, transparent);
  font-size: 12px;
  display: flex;
  align-items: center;
  .fact-share{
    img{
      height: 1.5rem;
      min-height: 25px;
    }
  }
  .logo{
    position: inherit !important;
  }
}

.splash-body{
  display: table-cell;
  vertical-align: middle;
  /*text-align: center;*/
  display:flex;
  flex-direction: column;
  /*align-items:center;*/
  justify-content: center;
  line-height: 1.3;
  font-weight: lighter;
  flex-grow:1;

  padding-left:2rem;
  padding-right:2rem;
  box-sizing: border-box;

}

.splash-footer{
  font-size: 0.8rem;
}



.splash-footer a:hover{
  color:#ffffff;
}

.splash-footer {
  flex-grow:0;
  display:flex;
  position:fixed;
  bottom:0px;
  left:0px;
  width:100vw;
  padding: 1.63rem;
  box-sizing: border-box;
  color:#aaaaaa;
  justify-content: space-between;
  align-items:flex-end;
}

.splash-footer>*:not(:last-child) {
    //margin-right:1rem;
}
#splash .fact-share{
  display: inherit;
}

a.data-download{
  color: #aaaaaa;
  position: fixed;
  bottom: 1.63rem;
}
a.data-download:hover{
  color:#ffffff;
}


.scroll-icon{
  min-width: 40px;
  width: 4.5em;
  height:2.5em;
  margin-top:2em;

  margin-left: auto!important;
  margin-right: auto!important;
  background: url(../assets/icons/scroll.svg);
  background-repeat: no-repeat;
  -webkit-animation-name:            scroll;
  -webkit-animation-duration:        1.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
}

@-webkit-keyframes scroll {
  0% {
    -webkit-transform: translateY(-3rem);
    opacity:0.0;
  }
  20% {
    opacity:0;
  }

  40% {
    opacity:1;
  }
  80% {
    opacity:1;
  }
  100% {
    -webkit-transform: translateY(-1rem);
    opacity:0;
  }
}
#splash a:hover{
  color:white;
}
#splash h2{
  font-size:2.65em;
  font-weight: lighter;
  color:white;
  max-width: 26em;
  margin-top:0em;
}

#splash h1{
  font-size:5.0em;
  font-weight: lighter;
  color:#ff6063;
  margin-top:0em;
  /*margin-left:auto;*/
  margin-right:auto;
  margin-bottom: 1.0em;
  margin-top:0em;
}



.splash-cols{
  z-index: 1;
  a, a:visited{
    color:#aaaaaa;
  }
  display:flex;
  >*{

  }
  >*:nth-child(1){
    max-width: 24em;
  }
  >*:nth-child(2){
    max-width: 24em;
    padding-left:3.26em;
    box-sizing: border-box;
    color:#aaaaaa;
    font-size: 1.85em;

  }
}
</style>
